import { UserHeaderDto } from './user-header.dto';

export interface ChatItemDetailsDto {
    isRoomMessage: boolean
    idRoom?: string
    idDestUser?: string
    destUserName?: string
    headerDto: UserHeaderDto,
    ticketFunctionalityActive?: boolean
}

export const createItemDetails = (
    isRoomMessage: boolean,
    idRoom: string | undefined,
    idDestUser: string | undefined,
    destUserName: string | undefined,
    headerDto: UserHeaderDto | undefined,
    ticketFunctionalityActive: boolean | undefined): ChatItemDetailsDto =>
    <ChatItemDetailsDto>{
        isRoomMessage: isRoomMessage,
        idRoom: idRoom,
        idDestUser: idDestUser,
        destUserName: destUserName,
        headerDto: headerDto,
        ticketFunctionalityActive: ticketFunctionalityActive
    }